import React from 'react';
import { PronunciationModal } from './pronunciation-modal.component';
import { usePronunciationModalPresenter } from './pronunciation-modal.presenter';
import type { PronunciationModalContainerProps } from './pronunciation-modal.types';

export const PronunciationModalContainer = (
  props: PronunciationModalContainerProps,
) => {
  const presenterProps = usePronunciationModalPresenter(props);
  return <PronunciationModal {...presenterProps} />;
};
